import { MoveStrategy } from './MoveStrategy';
import { Position, BoardState } from '../model/BoardState';

export class KnightMoveStrategy implements MoveStrategy {
  getLegalMoves(position: Position, boardState: BoardState): Position[] {
    const moves: Position[] = [];
    const { row, col } = position;
    const potentialMoves = [
      { row: row + 2, col: col + 1 },
      { row: row + 2, col: col - 1 },
      { row: row - 2, col: col + 1 },
      { row: row - 2, col: col - 1 },
      { row: row + 1, col: col + 2 },
      { row: row + 1, col: col - 2 },
      { row: row - 1, col: col + 2 },
      { row: row - 1, col: col - 2 },
    ];

    for (const move of potentialMoves) {
      if (this.isWithinBounds(move) && (!this.isBlocked(move, boardState) || this.isOpponentPiece(move, boardState, position))) {
        if (!moves.some(m => m.row === move.row && m.col === move.col)) {
          moves.push(move);
        }
      }
    }

    return moves;
  }

  getStrategyName(): string {
    return "Knight Move Strategy";
  }

  private isWithinBounds(position: Position): boolean {
    return position.row >= 0 && position.row < 8 && position.col >= 0 && position.col < 8;
  }

  private isBlocked(position: Position, boardState: BoardState): boolean {
    return boardState.pieces.some(piece => piece.position.row === position.row && piece.position.col === position.col);
  }

  private isOpponentPiece(position: Position, boardState: BoardState, currentPosition: Position): boolean {
    const piece = boardState.pieces.find(p => p.position.row === position.row && p.position.col === position.col);
    const currentPiece = boardState.pieces.find(p => p.position.row === currentPosition.row && p.position.col === currentPosition.col);
    return piece ? piece.color !== currentPiece?.color : false;
  }
}

